import { selectUserProjectId } from 'core/userContext';
import { useCampaignProjectLabels } from 'modules/campaigns/editor/hooks';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { ApiMethod } from 'services/api';
import { useRestMutation } from 'utils/hooks/api/useRestMutation';
import noop from 'utils/noop';
import { CampaignLabel } from 'modules/domains/campaign';
import { useCampaignQueryContext } from '../campaignFolders/contexts/CampaignQueryContext';
import { useCreateCampaignContext } from '../campaignFolders/contexts/CreateCampaignContext';

const CREATE_CAMPAIGN = '/campaigns/createSubmit';

export const useCreateCampaign = (onSuccess = noop) => {
  const history = useHistory();
  const projectId = useSelector(selectUserProjectId);
  const { mutate, isLoading } = useRestMutation(CREATE_CAMPAIGN, ApiMethod.post);
  const { results: campaignProjectLabels } = useCampaignProjectLabels();
  const { folderId } = useCampaignQueryContext();
  const { messageMedium } = useCreateCampaignContext();
  const dispatch = useDispatch();

  const createCampaign = (data: Record<string, any>) => {
    const campaign = data;

    const labels =
      campaignProjectLabels
        ?.filter((label: CampaignLabel) => campaign.labels?.includes(label?.name))
        ?.map((label: CampaignLabel) => ({ ...label, projectId })) || [];

    const newCampaign = {
      name: campaign.name,
      messageMedium,
      labels,
      campaignType: campaign.campaignType,
      destinationFolderId: folderId,
      mobileAppIds: campaign.mobileAppIds || [],
      // the fields below are not actually present
      // but they are required by the legacy endpoint
      dataScienceOptimizations: [],
      listIds: [], // TODO: figure out how to handle for blast campaigns
      embeddedCampaignProperties: {
        placementId: Number(campaign.placement),
      },
    };

    return mutate(newCampaign, {
      onError: (error: any) => {
        const responseErrorMessage = error?.response?.data?.message;
        const defaultErrorMessage = 'Please try again later.';
        const errorMessage = `Error creating campaign. ${
          responseErrorMessage || defaultErrorMessage
        }`;

        dispatch(addNegativeToastWithErrorId(errorMessage, 'createCampaign', error));
      },
      onSuccess: (resp) => {
        const { campaignId } = resp;
        history.push(`/campaigns/${campaignId}?view=Edit&template=default`);
        onSuccess();
      },
    });
  };

  return { createCampaign, isLoading };
};
